// extracted by mini-css-extract-plugin
module.exports = {"color-name-option-dot":"color-named-option__color-name-option-dot___dM9Oy"};